import React, { useEffect, useState } from "react";
import TextField from "../../components/textField/textField";
import { useParams } from "react-router-dom";
import TextArea from "../../components/textField/textArea";

import "./reportPage.css"
import Button from "../../components/button";
import { useAppContext } from "../../context/appContext";
import { PieceResponseDTOMin } from "../../openapi-generated-client";

export default function ReportPiecePage() {

    const {sessionId, pieceController, reportController} = useAppContext();

    const {id} = useParams();

    const [pieceData, setPieceData] = useState<PieceResponseDTOMin | undefined>(undefined);
    const [loading, setLoading] = useState(false);
    const [reason, setReason] = useState("");
    const [error, setError] = useState("");

    useEffect(() => {
        const fetchPieceData = async () => {
            if(id && !isNaN(Number(id))) {
                setPieceData((await pieceController.getPieceMin(Number(id))).data);
            }else {
                window.location.href = "/error/2";
            }
        };
        fetchPieceData();
    }, [id]);

    async function handleReport() {
        setLoading(true);
        if(!reason) {
            setError("Please provide a reason for reporting this piece.");
            return;
        }
        try {
            await reportController.reportPiece({
                pieceId: Number(id),
                reason: reason
            }, sessionId);
            window.location.href = "/pieces/" + id + "/report/success";
        }catch (e) {
            setError("An error occurred while submitting your report. Please try again later.");
        } finally {
            setLoading(false);
        }
    }

    return <div className="page report-page">
        <h1>Report Piece</h1>
        <h3>You're about to report the piece: {pieceData?.title}</h3>
        <p>Here you can report this piece if you think it violates our guidelines. Please provide as much information as possible to help us review your report.</p>
        <TextArea label="Reason for reporting" value={reason} onChange={setReason} placeholder="Describe the issue with this piece..." />
        <p className="error">{error}</p>
        <Button loading={loading} onClick={handleReport}>Send</Button>
    </div>


}